"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_VARIANTS = exports.BUTTON_TEXT_SIZES = exports.BUTTON_SIZES = void 0;
/** Available button variants */

var BUTTON_VARIANTS = {
  default: {
    primaryBlack: {
      backgroundColor: "black100",
      borderColor: "black100",
      color: "white100"
    },
    primaryWhite: {
      backgroundColor: "white100",
      borderColor: "white100",
      color: "black100"
    },
    secondaryGray: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "black100"
    },
    secondaryOutline: {
      backgroundColor: "transparent",
      borderColor: "black60",
      color: "black100"
    },
    noOutline: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    }
  },
  hover: {
    primaryBlack: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    primaryWhite: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    secondaryGray: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    secondaryOutline: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    noOutline: {
      backgroundColor: "blue10",
      borderColor: "blue10",
      color: "blue100",
      textDecoration: "underline"
    }
  },
  focus: {
    primaryBlack: {
      backgroundColor: "black100",
      borderColor: "blue100",
      color: "white100"
    },
    primaryWhite: {
      backgroundColor: "white100",
      borderColor: "blue100",
      color: "black100"
    },
    secondaryGray: {
      backgroundColor: "black10",
      borderColor: "blue100",
      color: "black100"
    },
    secondaryOutline: {
      backgroundColor: "transparent",
      borderColor: "blue100",
      color: "black100"
    },
    noOutline: {
      backgroundColor: "black10",
      borderColor: "blue100",
      color: "black100"
    }
  },
  loading: {
    primaryBlack: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    primaryWhite: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    secondaryGray: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    secondaryOutline: {
      backgroundColor: "blue100",
      borderColor: "blue100",
      color: "white100",
      textDecoration: "underline"
    },
    noOutline: {
      backgroundColor: "blue10",
      borderColor: "blue10",
      color: "blue100",
      textDecoration: "underline"
    }
  },
  disabled: {
    primaryBlack: {
      backgroundColor: "black30",
      borderColor: "black30",
      color: "white100"
    },
    primaryWhite: {
      backgroundColor: "black30",
      borderColor: "black30",
      color: "white100"
    },
    secondaryGray: {
      backgroundColor: "black30",
      borderColor: "black30",
      color: "white100"
    },
    secondaryOutline: {
      backgroundColor: "transparent",
      borderColor: "black30",
      color: "black30"
    },
    noOutline: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black30"
    }
  }
};
/** Available button sizes */

exports.BUTTON_VARIANTS = BUTTON_VARIANTS;
var BUTTON_SIZES = {
  small: {
    height: "30px",
    borderRadius: "15px",
    px: 2
  },
  medium: {
    height: "50px",
    borderRadius: "25px",
    px: 4
  },
  // Aliased to medium, for backwards compatability with v2
  large: {
    height: "50px",
    borderRadius: "25px",
    px: 4
  }
};
/** Text sizes associated with available button sizes */

exports.BUTTON_SIZES = BUTTON_SIZES;
var BUTTON_TEXT_SIZES = {
  small: "xs",
  medium: "sm",
  large: "sm"
};
exports.BUTTON_TEXT_SIZES = BUTTON_TEXT_SIZES;